import { v4 as uuid } from 'uuid'
import axios from 'axios'

import config from '../../config'
import { GET_CATEGORIES } from '../data/types'

/**
 * send a request and store its status in redux
 * @param {Object} payload 
 * @property {string} payload.type the type of redux action this request is. eg "GET_EVENTS" produces
 *    "GET_EVENTS_FETCH_REQUEST" then "GET_EVENTS_FETCH_SUCCESS" or "GET_EVENTS_FETCH_ERROR"
 * @property {Object} [payload.headers] optional headers to add to the request
 * @property {string} payload.url the resource location
 * @property {Object} payload.postData the post data as an Object, it will be converted to a JSON string
 * @property {function} [payload.withResult] optional callback called with arguments (error, response, payload)
 *    where payload is the object sent to this action and response is the response from the request
 */
export const sendRequest = payload => {
  const requiredProperties = ['type', 'url', 'postData']
  const missingKeys = requiredProperties.filter(key => !payload.hasOwnProperty(key))
  if (missingKeys.length) {
    // the payload is missing a required key
    console.error('sendRequest payload missing required keys: [', missingKeys.map(key => `"${key}"`).join(','), ' ]')
    return dispatch => dispatch({
      type: 'REQUEST_ERROR_MISSING_PARAMS',
      payload
    })
  }
  const requestID = uuid()
  const sentAt = new Date().getTime()
  const headers = {
    'wsc-api-key': config.apiAuthentication.vendorKey,
    'authorization': config.apiAuthentication.vendorName,
    'accept': 'application/json',
    'content-type': 'application/json'
  }
  if (payload.headers) {
    Object.keys(payload.headers).forEach(header => {
      if (payload.headers[header] === undefined) {
        delete headers[header]
      } else {
        headers[header] = payload.headers[header]
      }
    })
  }
  return (dispatch, getState) => {
    let calledWithResult = false
    dispatch({
      type: payload.type + '_FETCH_REQUEST',
      payload: { requestID, sentAt, ...payload }
    })
    axios
      .post(payload.url, payload.postData, {headers})
      .then(res => {
        const responseAt = new Date().getTime()
        if (res && res.data && res.data.errors && res.data.errors.hasError === true) {
          throw res && res.data && res.data.errors
        }

        dispatch({
          type: payload.type + '_FETCH_SUCCESS',
          payload: {
            requestID,
            sentAt,
            responseAt,
            ...payload,
            res,
          }
        })
        if (payload.withResult) {
          calledWithResult = true
          payload.withResult(null, res, payload)
        }
      })
      .catch(err => {
        const responseAt = new Date().getTime()
        console.error('Request Error:', err, payload)
        dispatch({
          type: payload.type + '_FETCH_ERROR',
          payload: {
            requestID,
            sentAt,
            responseAt,
            ...payload,
            error: err,
          },
          err
        })
        if (payload.withResult && !calledWithResult) {
          payload.withResult(err, null, payload)
        }
      })
  }
}

export const requestCategories = () => { //@TODO: refactor move this to data reducer actions
  return (dispatch, getState) => {
    const state = getState()
    const clientID = state.data.user.clientId
    
    dispatch(sendRequest({
      type: GET_CATEGORIES,
      url: `${config.uris.public}Categories/getCategories`,
      postData: { clientID }
    }))
  }
}
